import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { GlobalService } from '../global.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  public lightTheme = new BehaviorSubject<boolean>(this.checkTheme());

  constructor(
    public global: GlobalService,
    private meta: Meta
  ) { }

  public checkTheme(): boolean {
    let user = JSON.parse(localStorage.u || '{}');
    // let isLight: boolean = !this.global.ableThemeChange ? true : !!user.theme ? user.theme == 'light' ? true : false : matchMedia('(prefers-color-scheme: light)').matches ? true : false;
    let isLight: boolean = !this.global.ableThemeChange ? true : !!user.theme ? user.theme == 'light' ? true : false : false;
    isLight ? document.body.classList.remove('dark-theme') : document.body.classList.add('dark-theme');
    this.meta.addTag({ name: 'theme-color', content: isLight ? '#4579b5' : '#b60000' });
    return isLight;
  }

  public changeTheme() {
    let user = JSON.parse(localStorage.u || '{}');
    user.theme = this.checkTheme() ? 'dark' : 'light';
    localStorage.u = JSON.stringify(user);
    user.theme == 'light' ? document.body.classList.remove('dark-theme') : document.body.classList.add('dark-theme');
    this.meta.updateTag({ name: 'theme-color', content: user.theme == 'light' ? '#4579b5' : '#b60000' }, `name='theme-color'`);
    this.lightTheme.next(user.theme == 'light' ? true : false);
  }
}
